import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'

import PageLayout from 'components/layout/pageLayout'
import SubNavigation from 'components/layout/subNavigation'
import Head from 'components/layout/head'

interface ManualProps extends RouteComponentProps<any> {
  authenticated: boolean
  dispatch: any
}

type ManualState = {}

class Manual extends Component<ManualProps, ManualState> {
  constructor(props: ManualProps) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <PageLayout pageTitle="FAQ">
        <Head
          headline="FAQ"
          subheadline={
            process.env.REACT_APP_ENV === 'rigips'
              ? 'Mengenermittlung und Systemsuche - HORST'
              : 'ABK calcKit – der Baukasten für die schnelle Kalkulation'
          }
        />
        <SubNavigation
          items={[
            {
              label: 'Nutzungsbedingungen',
              link: '/faq/terms-of-use',
            },
            {
              label: 'Tutorial',
              link: '/faq/tutorial',
            },
            {
              label: 'Links',
              link: '/faq/links',
            },
          ]}
        />
        <div className="px-48 mb-65"></div>
      </PageLayout>
    )
  }
}

export default Manual
